import React from "react";
import styles from './stage-tag.module.scss'

interface StageTagProps {
    stage: string;
}

const STAGE_COLORS: Record<string, { bg: string; }> = {
    "design stage": { bg: "#E59E6D1A" },
    "as-built": { bg: "#B04A5A1A" },
};

const StageTag: React.FC<StageTagProps> = ({ stage }) => {
    const lowerStage = stage.toLowerCase();
    return (
        <div
            className={styles.stageTag}
            style={{ backgroundColor: STAGE_COLORS[lowerStage]?.bg }}
        >
            {stage}
        </div>
    )
}

export default StageTag;
